import React from "react";
var __jsx = React.createElement;
import { memo } from "react";
import { useTranslation } from "react-i18next";
import AwesomeIcon from "../../AwesomeIcon";
import { faGripLines, faStars, faCalculator, faXmark } from "@fortawesome/pro-regular-svg-icons";
import Image from "next/image";
import Store from "../../../utils/Store";
var MenuView = /*#__PURE__*/memo(function MenuView(_ref) {
  var patientId = _ref.patientId,
    onEnterScanCount = _ref.onEnterScanCount,
    onScanAssist = _ref.onScanAssist,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col flex-1 min-h-0 relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute top-0 right-0 w-full h-full pointer-events-none overflow-hidden rounded-2xl"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute w-[700px] h-[220px] top-[100px] -right-[240px] rotate-[135deg] rounded-[120px] bg-gradient-to-r from-[#833766] from-5% via-[#833766]/20 via-40% to-transparent to-60%"
  })), /*#__PURE__*/React.createElement("div", {
    className: "drag-handle cursor-grab active:cursor-grabbing flex items-start justify-center py-3 relative shrink-0"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faGripLines,
    className: "text-gray-500"
  }), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      onClose();
      Store.update(function (s) {
        s.isScanAssistModalOpen = false;
      });
    },
    className: "absolute top-2 right-3 z-10 text-gray-400 hover:text-gray-200 transition-colors p-1",
    "aria-label": "Close"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faXmark,
    size: "lg"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center px-8 pb-8 pt-2 flex-1 min-h-0 overflow-y-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "drag-handle flex-1 min-h-0 cursor-grab active:cursor-grabbing flex flex-col items-center justify-center space-y-7"
  }, /*#__PURE__*/React.createElement(Image, {
    src: "/assets/images/qureLogo.svg",
    alt: "qure.ai",
    width: 155,
    height: 52,
    priority: true,
    draggable: false
  }), /*#__PURE__*/React.createElement("p", {
    className: "text-gray-400 text-md uppercase text-center"
  }, "qTrack ID: ", /*#__PURE__*/React.createElement("br", null), " ", /*#__PURE__*/React.createElement("span", {
    className: "text-gray-100 text-base"
  }, patientId))), /*#__PURE__*/React.createElement("div", {
    className: "w-full space-y-4"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: onScanAssist,
    className: "w-full flex items-center gap-4 px-6 py-5 rounded-xl transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]",
    style: {
      background: "rgba(40, 55, 70, 0.6)",
      border: "1px solid rgba(100, 120, 140, 0.3)"
    }
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faStars,
    size: "lg",
    className: "text-teal-400"
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-gray-100 text-base font-medium"
  }, t("scan_assist", "Scan assist"))), /*#__PURE__*/React.createElement("button", {
    onClick: onEnterScanCount,
    className: "w-full flex items-center gap-4 px-6 py-5 rounded-xl transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]",
    style: {
      background: "rgba(40, 55, 70, 0.6)",
      border: "1px solid rgba(100, 120, 140, 0.3)"
    }
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faCalculator,
    size: "lg",
    className: "text-teal-400"
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-gray-100 text-base font-medium"
  }, t("enter_scan_count", "Enter scan count"))))));
});
export default MenuView;